/*global VeloxWebView*/


/**
 * Extension to search cities in ZIP Codes
 */
var extension = {} ;
extension.name = "filter-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "SAND"     :    { FR: true, DE: true, ES: true, GB: true}, 
    "GLASS"    :    { FR: true, DE: true, ES: true, GB: true}, 
    "CARTRIDGE":    { FR: true, DE: true, ES: true, GB: true}, 
    "POCKET"   :    { FR: true, DE: true, ES: true, GB: false}, 
    "DIATOM"  :     { FR: true, DE: true, ES: true, GB: true}, 
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_filter."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var filterEl = view.viewRootEl.querySelector('[data-field-def="pool.p_filter"]');
        if(filterEl){
            view.on("render", function(){
                filterEl.setOptions(computeOptions()) ;
            }) ;
        }   
    }) ;
} ;




module.exports = extension ;